import {
  PullToRefresh as SharedPullToRefresh,
  type PullToRefreshProps as SharedPullToRefreshProps,
} from '@/components/pull-to-refresh'

type Props = Omit<
  SharedPullToRefreshProps,
  'testId' | 'pullLabelKey' | 'releaseLabelKey' | 'refreshingLabelKey'
>

export function PullToRefresh(props: Props) {
  return (
    <SharedPullToRefresh
      {...props}
      testId="pull-to-refresh"
      pullLabelKey="discovery.pull.pull"
      releaseLabelKey="discovery.pull.release"
      refreshingLabelKey="discovery.refreshing"
    />
  )
}
